import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

const Wishlist = () => {
  const { wishlist } = useStore();
  if (wishlist.length === 0) return (
    <div className="flex flex-col items-center gap-4 py-32 text-center" data-testid="empty-wishlist">
      <Heart className="h-14 w-14 text-muted-text/40" />
      <h1 className="font-serif text-3xl text-charcoal">Your wishlist is empty</h1>
      <p className="text-muted-text">Save your favourite styles for later.</p>
      <Button asChild className="rounded-none bg-burgundy"><Link to="/new-arrivals">Explore Collection</Link></Button>
    </div>
  );
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
      <h1 className="font-serif text-4xl text-burgundy">My Wishlist ({wishlist.length})</h1>
      <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-4">
        {wishlist.map((p) => <ProductCard key={p.id} product={{ ...p, reviews_count: 0 }} />)}
      </div>
    </div>
  );
};

export default Wishlist;
